{
  "label": "apparato",
  "name": "Nome",
  "model": "Gamma",
  "type": "Tipo",
  "serialNumber": "Numero di serie",
  "sector": "Rete",
  "connectivity": "Connettività",
  "certificate": "Certificato",
  "state": "Stato",
  "states": {
    "activated": "Attivato",
    "deactivated": "Disattivato",
    "registered": "Nuovo"
  },
  "actions": {
    "scheduled": {
      "title": "Azioni in corso?",
      "yes": "Sì",
      "no": "No",
      "error": "Indeterminato"
    }
  },
  "firmwareVersion": "Versione software",
  "hardwareVersion": "Versione hardware",
  "updateCertificate": "Aggiornamento del certificato",
  "updateFirmware": "Aggiornamento del firmware",
  "updateState": {
    "activate": {
      "title": "Attivare",
      "execute": "Attivare l’apparato",
      "description": "L’apparato {name} sarà attivato."
    },
    "deactivate": {
      "title": "Disattivare",
      "execute": "Disattivare l’apparato",
      "description": "L’apparato {name} sarà disattivato.",
      "warning": "Un apparato disattivato non usufruisce più degli aggiornamenti manuali e automatici dei certificati.",
      "error": "Questo apparato non può essere disattivato perché presenta un’operazione pianificato o in corso."
    }
  },
  "month": "{n} mese | {n} mesi",
  "year": "{n} anno | {n} anni",
  "custom": "Personalizzato",
  "dateFormat": "DD/MM/YYYY HH:mm",
  "empty": "Non è stato trovato nessun apparato",
  "delete": {
    "execute": "Eliminare l’apparato",
    "description": "L’apparato {name} sarà eliminato.",
    "warning": "Anche le operazioni associate all’apparato saranno eliminate.",
    "error": "Questo apparato non può essere eliminato perché presenta un’operazione pianificato o in corso."
  },
  "description": {
    "title": "Descrizione",
    "idCard": "Carta d’identità",
    "state": "Stato",
    "connectivity": "Connettività",
    "lastConnection": "Ultima connessione",
    "certificateValidityDate": "Data di validità del certificato",
    "lastChange": "Ultima modifica",
    "configurationApplicationDate": "Data di applicazione della configurazione",
    "lastRebootDate": "Data dell’ultimo riavvio",
    "firstCommissioningDate": "Data della prima messa in servizio",
    "lastFirmwareUpdate": "Ultimo aggiornamento del firmware",
    "mobileNetwork": "Rete mobile",
    "gsmFrequencyBand": "Banda di frequenza GSM",
    "communicationProtocol": "Protocollo comunicazione"
  },
  "certificateForm": {
    "expirationDate": "Data di scadenza del certificato",
    "certificateOrigin": "Origine del certificato",
    "lastUpdate": "Ultimo aggiornamento del certificato"
  },
  "firmwareForm": {
    "title": "Firmware",
    "version": "Versione",
    "description": "Descrizione del firmware",
    "origin": "Origine del firmware",
    "lastUpdate": "Ultimo aggiornamento"
  },
  "configurationForm": {
    "title": "Configurazione"
  },
  "operation": {
    "cancel": {
      "tooltip": {
        "enabled": "Annulla l’operazione",
        "disabled": "Non è più possibile annullare l’operazione"
      },
      "confirm": {
        "title": "Annullamento dell’operazione",
        "description": "Questa operazione verrà annullata. Questa azione è invertibile."
      }
    },
    "unitary": "Unitari",
    "campaign": "Campagne",
    "update": {
      "tooltip": {
        "enabled": "Aggiorna l’operazione",
        "disabled": "Non è più possibile modificare l’operazione"
      }
    }
  },
  "additionalMetadata": {
    "title": "Metadati aggiuntivi",
    "options": {
      "title": "Opzioni",
      "software": {
        "1": "Automatismo",
        "2": "Stazione di sollevamento",
        "3": "Server Web",
        "4": "Sinottici Web",
        "5": "Emergenza IP ADSL / GSM",
        "6": "IEC60870-5-104 Slave"
      },
      "numericSoftware": {
        "1": "N. di informazioni: {value}",
        "2": "Numero di moduli I/O: {value}",
        "3": "Numero di moduli COM: {value}"
      }
    },
    "communicationModules": {
      "title": "Moduli di comunicazione"
    },
    "modulesIo": {
      "title": "Moduli I/O"
    },
    "modules": {
      "location": "Posizione",
      "module": "Module"
    }
  },
  "warningMessage": "L’apparato presenta già un’operazione dello stesso tipo pianificata o in corso"
}
